import { differenceInMinutes, format, formatDistanceStrict, isSameYear } from 'date-fns';
import { safeFromUnixTime } from './dates';

export const COUNTDOWN_CUTOFF_DAYS_IN_MINUTES = 10080; // 7 days

export const showCountDownBasedOnMinimumDate = auctionDate => {
    const now = new Date();
    const upcoming = safeFromUnixTime(auctionDate);
    const totalDays = differenceInMinutes(upcoming, now);

    return totalDays <= COUNTDOWN_CUTOFF_DAYS_IN_MINUTES;
};

export const getCountDown = (auctionTs, forceYear = false) => {
    const now = new Date();
    const upcoming = safeFromUnixTime(auctionTs);
    let countDown = false;

    let dateFormat =
        isSameYear(now, upcoming) && !forceYear ? format(upcoming, 'MMM dd') : format(upcoming, 'MMM dd, yyyy');

    const totalMinutesUntil = differenceInMinutes(upcoming, now);
    if (totalMinutesUntil > 0 && totalMinutesUntil <= COUNTDOWN_CUTOFF_DAYS_IN_MINUTES) {
        // date-fns has no option for abbreviations so we'll do it here
        dateFormat = formatDistanceStrict(now, upcoming);
        dateFormat = dateFormat
            .replace('hours', 'hrs')
            .replace('hour', 'hr')
            .replace('minutes', 'mins')
            .replace('minute', 'min');
        countDown = true;
    }

    return {
        countDown,
        dateFormat,
    };
};

export const countDownTimeStamp = secondsInput => {
    const response = {};

    // Get hours from milliseconds
    const hours = secondsInput / (60 * 60);
    let hour = Math.floor(hours);

    // Get remainder from hours and convert to minutes
    const minutes = (hours - hour) * 60;
    const minute = Math.floor(minutes);

    // Get remainder from minutes and convert to seconds
    const seconds = (minutes - minute) * 60;
    const second = Math.floor(seconds);

    if (hour > 24) {
        response.days = Math.floor(hour / 24);
        hour = hour % 24;
    }

    if (hour) {
        response.hours = hour;
    }

    if (minute) {
        response.minutes = minute;
    }

    if (second) {
        response.seconds = second;
    }

    return response;
};
